import { cva } from 'class-variance-authority';

export const videoElementStyles = cva(
  [
    'w-full h-full object-contain',
    '[&:fullscreen] {object-contain w-100vw h-auto}',
    '[&::-webkit-full-screen] {object-contain w-100vw h-auto}',
    '[&:-moz-full-screen] {object-contain w-100vw h-auto}',
    '[&:-ms-fullscreen] {object-contain w-100vw h-auto}',
  ],
  {
    variants: {},
  }
);
